import { useContext, useEffect } from 'react'
import { SiteConfigContext } from '../SiteConfigProvider'
import { isBrowser, useScript } from '@jelly/utils'

export function DfpAdUnitSetup({ channels, docType, guid }) {
	const [loaded, error] = useScript('https://www.googletagservices.com/tag/js/gpt.js')
	const isArticle = 'article' === docType

	const {
		siteConstants: { DFP_CONTENT_ID_TYPE = 'guid', DFP_NETWORK_ID, DFP_NOBID_ID, DFP_SITE_NAME },
	} = useContext(SiteConfigContext)

	useEffect(() => {
		if (error) {
			return console.warn('Failed to load gpt.js')
		}

		if (isBrowser() && loaded) {
			isArticle &&
				(function () {
					var s = document.createElement('script')
					s.type = 'text/javascript'
					s.async = true
					s.src = 'https://public.servenobid.com/nobidtag/nobidtag.js'
					var x = document.getElementsByTagName('script')[0]
					x.parentNode.insertBefore(s, x)
				})()
			const hostname = window.location.hostname
			const url = window.location.origin + window.location.pathname
			const searchTerm = ''

			// pulls out the first numeric part of the URL path, for example:
			// https://www.businessnewsdaily.com/5102-green-business-ideas.html
			// will produce "5102". If no number val is undefined
			const idFromHref = window.location.pathname.match(/[\d]+/)

			// set the content_id according to the method defined in the site config
			// if set to "prefix" and there is no number in the URL, deafult to "guid"
			const contentId =
				DFP_CONTENT_ID_TYPE === 'prefix' && idFromHref
					? `${DFP_SITE_NAME}-${idFromHref[0]}`
					: `${guid}`.replace(/^[a-z]+_/i, '')

			const contentType = `${docType}`.trim().replace(/\s/g, '_')
			const pageAdZone = channels.sub
				? [`${channels?.primary?.slug}`, `${channels?.sub?.slug}`].join('/')
				: `${channels?.primary?.slug}`
			const pageAccount = DFP_NETWORK_ID
			const site = DFP_SITE_NAME
			const zoneType = site
			const adunitZone = [
				pageAccount,
				zoneType +
					'-' +
					contentType.replace(/^\w/, function (c) {
						return c.toUpperCase()
					}),
				`${docType}`,
			].join('/')

			const inArticleSizes = [
					[728, 90],
					[632, 81],
					[720, 250],
					[720, 400],
				],
				leaderboardSizes = [
					[728, 90],
					[970, 90],
					[970, 250],
					[970, 490],
					[970, 450],
					[970, 66],
					[930, 490],
					[930, 450],
					[930, 250],
					[930, 140],
					[632, 81],
				],
				mobileAdSizes = [
					[320, 50],
					[300, 50],
					[300, 100],
					[234, 60],
				],
				railSizes = [
					[300, 250],
					[250, 250],
					[336, 280],
					[180, 150],
					[200, 200],
				]

			window.googletag = window.googletag || {}
			window.googletag.cmd = window.googletag.cmd || []
			window.googletag.cmd.push(function () {
				window.googletag.cmd.push(function () {
					const inArticleSizeMap = window.googletag
						.sizeMapping()
						.addSize([768, 0], [320, 50])
						.addSize([1024, 0], [560, 60])
						.addSize([1200, 0], inArticleSizes)
						.addSize([0, 0], mobileAdSizes)
						.build()

					const leaderBoardSizeMap = window.googletag
						.sizeMapping()
						.addSize([768, 0], [320, 50])
						.addSize([1024, 0], [560, 60])
						.addSize([1200, 0], leaderboardSizes)
						.addSize([0, 0], mobileAdSizes)
						.build()

					const railAdSizeMap = window.googletag.sizeMapping().addSize([0, 0], railSizes).build()

					if (document.getElementById('ad_leaderboard')) {
						window.googletag
							.defineSlot(adunitZone, [[320, 50]], 'ad_leaderboard')
							.defineSizeMapping(leaderBoardSizeMap)
							.addService(window.googletag.pubads())
							.setTargeting('position', 'a1')
					}

					window.googletag.defineOutOfPageSlot(adunitZone, 'out-of-page')

					if (document.getElementById('in-article-vca-1')) {
						window.googletag
							.defineSlot(adunitZone, [[320, 50]], 'in-article-vca-1')
							.addService(window.googletag.pubads())
							.defineSizeMapping(inArticleSizeMap)
							.setTargeting('position', 'a2')
					}

					if (document.getElementById('in-article-vca-2')) {
						window.googletag
							.defineSlot(adunitZone, [[320, 50]], 'in-article-vca-2')
							.defineSizeMapping(inArticleSizeMap)
							.addService(window.googletag.pubads())
							.setTargeting('position', 'a3')
					}

					if (document.getElementById('adunit-atf')) {
						window.googletag
							.defineSlot(adunitZone, [[300, 250]], 'adunit-atf')
							.defineSizeMapping(railAdSizeMap)
							.addService(window.googletag.pubads())
							.setTargeting('position', 'a2')
					}
					if (document.getElementById('adunit-btf')) {
						window.googletag
							.defineSlot(adunitZone, [[320, 250]], 'adunit-btf')
							.defineSizeMapping(railAdSizeMap)
							.addService(window.googletag.pubads())
							.setTargeting('position', 'a4')
					}

					window.googletag
						.pubads()
						.setTargeting('content_id', contentId)
						.setTargeting('search_term', searchTerm)
						.setTargeting('content_type', [contentType])
						.setTargeting('host', hostname)
						.setTargeting('page_zone', [pageAdZone])
						.setTargeting('URL', url)
						.setTargeting('zone_type', [zoneType])

					window.googletag.pubads().enableSingleRequest()
					window.googletag.pubads().collapseEmptyDivs()
					// Only include this for nobid header code on articles
					isArticle && window.googletag.pubads().disableInitialLoad()
					window.googletag.enableServices()

					if (document.getElementById('in-article-vca-1')) {
						window.googletag.cmd.push(function () {
							window.googletag.display('in-article-vca-1')
						})
					}
					if (document.getElementById('in-article-vca-2')) {
						window.googletag.cmd.push(function () {
							window.googletag.display('in-article-vca-2')
						})
					}
					if (document.getElementById('adunit-atf')) {
						window.googletag.cmd.push(function () {
							window.googletag.display('adunit-atf')
						})
					}
				})
				if (isArticle) {
					window.nobidtag = window.nobidtag || {}
					window.nobidtag.cmd = window.nobidtag.cmd || []
					window.googletag.cmd.push(function () {
						window.nobidtag.cmd.push(function () {
							var config = {
								siteId: DFP_NOBID_ID,
								timeout: 3000,
								adunits: [
									{
										id: 'ad_leaderboard',
										sizes: leaderboardSizes,
										responsive: [
											{ screenWidth: 632, sizes: leaderboardSizes },
											{ screenWidth: 0, sizes: mobileAdSizes },
										],
									},
									{ id: 'adunit-atf', sizes: railSizes },
									{
										id: 'in-article-vca-1',
										sizes: inArticleSizes,
										responsive: [
											{ screenWidth: 632, sizes: inArticleSizes },
											{ screenWidth: 0, sizes: mobileAdSizes },
										],
									},
									{
										id: 'in-article-vca-2',
										sizes: inArticleSizes,
										responsive: [
											{ screenWidth: 632, sizes: inArticleSizes },
											{ screenWidth: 0, sizes: mobileAdSizes },
										],
									},
									{ id: 'adunit-btf', sizes: railSizes },
								],
							}
							window.nobidtag.refreshAds(config)
						})
					})
				}
			})
		}
	}, [
		loaded,
		error,
		guid,
		docType,
		channels,
		isArticle,
		DFP_NETWORK_ID,
		DFP_SITE_NAME,
		DFP_NOBID_ID,
		DFP_CONTENT_ID_TYPE,
	])
	return null
}
